import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router' // 导入路由实例


// 创建 axios 实例
const service = axios.create({
  baseURL: 'https://www.sqwlgz.xin:8008', // API 基础路径，使用相对路径通过代理转发
  timeout: 60000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json'
  },
  // ✅ 添加 paramsSerializer，让数组序列化为 Status=3&Status=4&Status=5
  paramsSerializer: function(params) {
    const parts = []
    Object.keys(params).forEach(key => {
      const value = params[key]
      // 跳过空值
      if (value === null || value === undefined || value === '') {
        return
      }
      // 处理数组：Status=3&Status=4&Status=5
      if (Array.isArray(value)) {
        if (value.length === 0) {
          return
        }
        value.forEach(item => {
          parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(item))
        })
      } else {
        parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(value))
      }
    })
    return parts.join('&')
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从本地存储获取 token
    const token = localStorage.getItem('token')
    // 如果有 token，添加到请求头
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    // 处理请求错误
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
	  const res = response.data
	  if(response.config.method==='get'&&response.config.params&&response.config.params.isCarRequest===1){
		  return res
	  }
    // 如果响应 ret 不是 1000，视为错误
    if (res.ret !== 1000) {
      // 处理错误，显示错误信息
      const errorMsg = res.msg || '请求失败'
      console.error('响应错误:', errorMsg)
      Message.error(errorMsg)
      return Promise.reject(new Error(errorMsg))
    } else {
      return res
    }
  },
  error => {
	  console.log(error.response)
	  const errData = error.response
	  if(errData){
		  if(errData.status===401){
			  router.replace('/login')
		  }else  if(errData.status===403){
			  Message.error("没有权限访问哦；请联系管理员")
			  return Promise.reject()
		  }else  if(errData.status===400){
			  const data = errData.data
            if (data?.msg) {
                Message.error(data.msg)
                return Promise.reject()
            }
            if (data && data.errors) {
                // 遍历errors对象，提取所有错误信息
                const errorMessages = []
                Object.keys(data.errors).forEach(key => {
                    const msgs = data.errors[key]
                    if (Array.isArray(msgs)) {
                        errorMessages.push(...msgs)
                    } else {
                        errorMessages.push(msgs)
                    }
                })
                // 显示第一个错误，或合并显示
                Message.error(errorMessages.join('；') || '数据验证失败')
            } else {
                Message.error(data?.title || '请求参数错误')
            }
            return Promise.reject()
        }else{
			  const errRes = errData.data
			  Message.error(errRes.msg|| '网络错误')
			  return Promise.reject()
		  }
		  return
	  }
    // 处理响应错误
//    Message.error(error.msg || '网络错误')
    return Promise.reject(error)
  }
)

// 封装常用的 HTTP 方法
const api = {
  // GET 请求
  get(url, params = {}) {
    return service({
      url,
      method: 'get',
      params
    })
  },
  
  // POST 请求
  post(url, data = {}) {
    return service({
      url,
      method: 'post',
      data
    })
  },
  
  // PUT 请求
  put(url, data = {}) {
    return service({
      url,
      method: 'put',
      data
    })
  },
  
  // DELETE 请求
  delete(url, params = {}) {
    return service({
      url,
      method: 'delete',
      params
    })
  },
  
  // PATCH 请求
  patch(url, data = {}) {
    return service({
      url,
      method: 'patch',
      data
    })
  },
  
  // Account 模块
  account: {
    // 获取验证码
    getCaptcha() {
      return service({
        url: '/api/account/generate',
        method: 'get'
      })
    },
    // 注册用户
    register(data) {
      return service({
        url: '/api/account/register',
        method: 'post',
        data
      })
    },
    // 修改用户信息
    updateUser(userId, data) {
      return service({
        url: `/api/account/users/${userId}`,
        method: 'put',
        data
      })
    },
    // 用户自行修改密码
    selfChangePassword(oldPassword, newPassword) {
      return service({
        url: '/api/account/SelfChangeUserPassword',
        method: 'post',
        params: { oldPassword, newPassword }
      })
    },
    // 用户登录
    login(data) {
      return service({
        url: '/api/account/login',
        method: 'post',
        data
      })
    },
    // 获取当前用户信息
    getUserInfo() {
      return service({
        url: '/api/account/userinfo',
        method: 'get'
      })
    },
    // 登出
    logout() {
      return service({
        url: '/api/account/logout',
        method: 'post'
      })
    },
    // 获取用户列表
    getUsers(params) {
      return service({
        url: '/api/account/getsuers',
        method: 'get',
        params
      })
    },
    // 注册用户检索
    getResUser(params) {
      return service({
        url: '/api/account/getResUser',
        method: 'get',
        params
      })
    }
  },
  
  // Captcha 模块
  captcha: {
    // 生成验证码
    generate() {
      return service({
        url: '/generate',
        method: 'get'
      })
    },
    // 验证验证码
    validate(data) {
      return service({
        url: '/validate',
        method: 'post',
        data
      })
    }
  },
  
  // Coupons 模块
  coupons: {
    // 获取优惠券列表
    getCoupons(params) {
      return service({
        url: '/api/Coupons',
        method: 'get',
        params
      })
    }
  },
  
  // DataCategories 模块
  dataCategories: {
    // 获取所有数据类别
    getCategories(params) {
      return service({
        url: '/api/DataCategories',
        method: 'get',
        params
      })
    },
    // 创建数据类别
    createCategory(data) {
      return service({
        url: '/api/DataCategories',
        method: 'post',
        data
      })
    },
    // 获取指定ID的数据分类
    getCategory(id) {
      return service({
        url: `/api/DataCategories/${id}`,
        method: 'get'
      })
    },
    // 更新数据类别
    updateCategory(id, data) {
      return service({
        url: `/api/DataCategories/${id}`,
        method: 'put',
        data
      })
    },
    // 删除数据类别
    deleteCategory(id) {
      return service({
        url: `/api/DataCategories/${id}`,
        method: 'delete'
      })
    }
  },
  
  // Jobs 模块
  jobs: {
    // 获取所有任务
    getJobs() {
      return service({
        url: '/api/Jobs',
        method: 'get'
      })
    },
    // 添加新任务
    createJob(data) {
      return service({
        url: '/api/Jobs',
        method: 'post',
        data
      })
    },
    // 暂停任务
    pauseJob(jobGroup, jobName) {
      return service({
        url: `/api/Jobs/${jobGroup}/${jobName}/pause`,
        method: 'post'
      })
    },
    // 恢复任务
    resumeJob(jobGroup, jobName) {
      return service({
        url: `/api/Jobs/${jobGroup}/${jobName}/resume`,
        method: 'post'
      })
    },
    // 删除任务
    deleteJob(jobGroup, jobName) {
      return service({
        url: `/api/Jobs/${jobGroup}/${jobName}`,
        method: 'delete'
      })
    },
    // 立即触发任务
    triggerJob(jobGroup, jobName) {
      return service({
        url: `/api/Jobs/${jobGroup}/${jobName}/trigger`,
        method: 'post'
      })
    },
    // 更新任务调度
    updateSchedule(triggerGroup, triggerName, cronExpression) {
      return service({
        url: `/api/Jobs/${triggerGroup}/${triggerName}/schedule`,
        method: 'put',
        data: cronExpression
      })
    }
  },
  
  // Menus 模块
  menus: {
    // 获取所有菜单（树形结构）
    getMenus() {
      return service({
        url: '/api/Menus',
        method: 'get'
      })
    },
    // 添加菜单
    createMenu(data) {
      return service({
        url: '/api/Menus',
        method: 'post',
        data
      })
    },
    // 根据角色获取菜单权限
    getRoleMenus(roleId) {
      return service({
        url: `/api/Menus/GetRoleMenus/${roleId}`,
        method: 'get'
      })
    },
    // 获取用户菜单
    getUserMenus() {
      return service({
        url: '/api/Menus/GetUserMenus',
        method: 'get'
      })
    },
    // 获取单个菜单
    getMenu(id) {
      return service({
        url: `/api/Menus/${id}`,
        method: 'get'
      })
    },
    // 更新菜单
    updateMenu(id, data) {
      return service({
        url: `/api/Menus/${id}`,
        method: 'put',
        data
      })
    },
    // 删除菜单
    deleteMenu(id) {
      return service({
        url: `/api/Menus/${id}`,
        method: 'delete'
      })
    },
    // 批量更新角色菜单权限
    updateRoleMenus(roleId, menuIds) {
      return service({
        url: `/api/Menus/UpdateRoleMenus/${roleId}`,
        method: 'put',
        data: menuIds
      })
    }
  },
  
  // PassengerFlow 模块
  passengerFlow: {
    // 获取场所信息
    getSites() {
      return service({
        url: '/api/PassengerFlow/sites',
        method: 'post'
      })
    },
    // 获取客流数据（按时间范围）
    getDataRange(data) {
      return service({
        url: '/api/PassengerFlow/data-range',
        method: 'post',
        data
      })
    }
  },
  
  // Permissions 模块
  permissions: {
    // 获取权限列表
    getPermissions(params) {
      return service({
        url: '/api/Permissions',
        method: 'get',
        params
      })
    },
    // 创建权限
    createPermission(data) {
      return service({
        url: '/api/Permissions',
        method: 'post',
        data
      })
    },
    // 获取指定权限
    getPermission(id) {
      return service({
        url: `/api/Permissions/${id}`,
        method: 'get'
      })
    },
    // 更新权限
    updatePermission(id, data) {
      return service({
        url: `/api/Permissions/${id}`,
        method: 'put',
        data
      })
    },
    // 删除权限
    deletePermission(id) {
      return service({
        url: `/api/Permissions/${id}`,
        method: 'delete'
      })
    }
  },
  
  // RolePermissions 模块
  rolePermissions: {
    // 获取角色权限
    getRolePermissions(params) {
      return service({
        url: '/api/RolePermissions',
        method: 'get',
        params
      })
    },
    // 根据角色匹配角色权限
    getRolePermissionPro(roleId) {
      return service({
        url: '/api/RolePermissions/GetRolePermissionPro',
        method: 'get',
        params: { roleId }
      })
    },
    // 批量更新角色权限
    updateRolePermissions(roleId, data) {
      return service({
        url: `/api/RolePermissions/${roleId}`,
        method: 'put',
        data
      })
    }
  },
  
  // Roles 模块
  roles: {
    // 获取角色列表
    getRoles(params) {
      return service({
        url: '/api/Roles',
        method: 'get',
        params
      })
    },
    // 创建角色
    createRole(data) {
      return service({
        url: '/api/Roles',
        method: 'post',
        data
      })
    },
    // 获取指定角色
    getRole(id) {
      return service({
        url: `/api/Roles/${id}`,
        method: 'get'
      })
    },
    // 修改角色
    updateRole(id, data) {
      return service({
        url: `/api/Roles/${id}`,
        method: 'put',
        data
      })
    },
    // 删除角色
    deleteRole(id) {
      return service({
        url: `/api/Roles/${id}`,
        method: 'delete'
      })
    }
  },
  
  // TruckType 模块
  truckType: {
    // 获取所有车类型
    getTruckTypes() {
      return service({
        url: '/api/TruckType',
        method: 'get'
      })
    },
    // 创建车类型
    createTruckType(data) {
      return service({
        url: '/api/TruckType',
        method: 'post',
        data
      })
    },
    // 分页获取车类型
    getTruckTypesPaged(params) {
      return service({
        url: '/api/TruckType/paged',
        method: 'get',
        params
      })
    },
    // 获取启用的车类型
    getActiveTruckTypes() {
      return service({
        url: '/api/TruckType/active',
        method: 'get'
      })
    },
    // 根据ID获取车类型
    getTruckType(id) {
      return service({
        url: `/api/TruckType/${id}`,
        method: 'get'
      })
    },
    // 更新车类型
    updateTruckType(id, data) {
      return service({
        url: `/api/TruckType/${id}`,
        method: 'put',
        data
      })
    },
    // 删除车类型
    deleteTruckType(id) {
      return service({
        url: `/api/TruckType/${id}`,
        method: 'delete'
      })
    },
    // 切换车类型状态
    toggleTruckTypeStatus(id, isActive) {
      return service({
        url: `/api/TruckType/${id}/status`,
        method: 'patch',
        params: { isActive }
      })
    },
    // 检查车类型名称是否存在
    checkTruckTypeName(name, excludeId) {
      return service({
        url: '/api/TruckType/check-name',
        method: 'get',
        params: { name, excludeId }
      })
    },
    // 获取车类型总数
    getTruckTypeCount() {
      return service({
        url: '/api/TruckType/count',
        method: 'get'
      })
    }
  },
  
  // UserRoles 模块
  userRoles: {
    // 获取用户角色列表
    getUserRoles(params) {
      return service({
        url: '/api/UserRoles',
        method: 'get',
        params
      })
    }
  },
  
  // Drivers 模块
  drivers: {
    // 获取驾驶员列表
    getDrivers(params) {
      return service({
        url: '/api/Drivers',
        method: 'get',
        params
      })
    },
    // 创建新驾驶员
    createDriver(data) {
      return service({
        url: '/api/Drivers',
        method: 'post',
        data
      })
    },
    // 获取单个驾驶员详情
    getDriver(id) {
      return service({
        url: `/api/Drivers/${id}`,
        method: 'get'
      })
    },
    // 更新驾驶员信息
    updateDriver(id, data) {
      return service({
        url: `/api/Drivers/${id}`,
        method: 'put',
        data
      })
    },
    // 删除驾驶员
    deleteDriver(id) {
      return service({
        url: `/api/Drivers/${id}`,
        method: 'delete'
      })
    },
    // 根据身份证号获取驾驶员
    getDriverByIdCard(idCardNumber) {
      return service({
        url: `/api/Drivers/by-idcard/${idCardNumber}`,
        method: 'get'
      })
    },
    // 审核驾驶员
    auditDriver(data) {
      return service({
        url: '/api/Drivers/audit',
        method: 'post',
        data
      })
    },
    // 批量删除驾驶员
    batchDeleteDrivers(ids) {
      return service({
        url: '/api/Drivers/batch',
        method: 'delete',
        data: ids
      })
    },
    // 更新驾驶员状态
    updateDriverStatus(id, data) {
      return service({
        url: `/api/Drivers/${id}/status`,
        method: 'patch',
        data
      })
    }
  },
  
  // Archives 模块
  archives: {
    // 获取档案列表
    getArchives(params) {
      return service({
        url: '/api/Archives',
        method: 'get',
        params
      })
    },
    // 创建档案
    createArchive(data) {
      return service({
        url: '/api/Archives',
        method: 'post',
        data
      })
    },
    // 获取单个档案详情
    getArchive(id) {
      return service({
        url: `/api/Archives/${id}`,
        method: 'get'
      })
    },
    // 更新档案
    updateArchive(id, data) {
      return service({
        url: `/api/Archives/${id}`,
        method: 'put',
        data
      })
    },
    // 删除档案
    deleteArchive(id) {
      return service({
        url: `/api/Archives/${id}`,
        method: 'delete'
      })
    },
    // 获取指定人员的档案
    getPersonArchives(personId) {
      return service({
        url: `/api/Archives/person/${personId}`,
        method: 'get'
      })
    },
    // 获取指定车辆的档案
    getVehicleArchives(vehicleId) {
      return service({
        url: `/api/Archives/vehicle/${vehicleId}`,
        method: 'get'
      })
    },
    // 获取指定类型的档案
    getTypeArchives(archiveTypeId) {
      return service({
        url: `/api/Archives/type/${archiveTypeId}`,
        method: 'get'
      })
    },
    // 批量创建档案
    batchCreateArchives(data) {
      return service({
        url: '/api/Archives/batch',
        method: 'post',
        data
      })
    },
    // 批量删除档案
    batchDeleteArchives(ids) {
      return service({
        url: '/api/Archives/batch',
        method: 'delete',
        data: ids
      })
    },
    // 审核档案
    auditArchive(data) {
      return service({
        url: '/api/Archives/audit',
        method: 'post',
        data
      })
    },
    // 获取档案统计数据
    getArchiveStatistics(params) {
      return service({
        url: '/api/Archives/statistics',
        method: 'get',
        params
      })
    },
    // 获取即将过期的档案
    getExpiringArchives(params) {
      return service({
        url: '/api/Archives/expiring',
        method: 'get',
        params
      })
    },
    // 获取所有档案类型
    getArchiveTypes(params) {
      return service({
        url: '/api/Archives/archive-types',
        method: 'get',
        params
      })
    },
    // 获取档案类别列表
    getArchiveCategories() {
      return service({
        url: '/api/Archives/categories',
        method: 'get'
      })
    }
  },
  
  // ArchiveTypes 模块
  archiveTypes: {
    // 获取档案类型列表
    getArchiveTypes(params) {
      return service({
        url: '/api/ArchiveTypes',
        method: 'get',
        params
      })
    },
    // 创建档案类型
    createArchiveType(data) {
      return service({
        url: '/api/ArchiveTypes',
        method: 'post',
        data
      })
    },
    // 获取单个档案类型详情
    getArchiveType(id) {
      return service({
        url: `/api/ArchiveTypes/${id}`,
        method: 'get'
      })
    },
    // 更新档案类型
    updateArchiveType(id, data) {
      return service({
        url: `/api/ArchiveTypes/${id}`,
        method: 'put',
        data
      })
    },
    // 删除档案类型
    deleteArchiveType(id) {
      return service({
        url: `/api/ArchiveTypes/${id}`,
        method: 'delete'
      })
    },
    // 根据类别获取档案类型
    getArchiveTypesByCategory(category) {
      return service({
        url: `/api/ArchiveTypes/by-category/${category}`,
        method: 'get'
      })
    },
    // 获取人员档案类型
    getPersonArchiveTypes() {
      return service({
        url: '/api/ArchiveTypes/person',
        method: 'get'
      })
    },
    // 获取车辆档案类型
    getVehicleArchiveTypes() {
      return service({
        url: '/api/ArchiveTypes/vehicle',
        method: 'get'
      })
    },
    // 批量删除档案类型
    batchDeleteArchiveTypes(ids) {
      return service({
        url: '/api/ArchiveTypes/batch',
        method: 'delete',
        data: ids
      })
    },
    // 启用档案类型
    activateArchiveType(id) {
      return service({
        url: `/api/ArchiveTypes/${id}/activate`,
        method: 'post'
      })
    },
    // 禁用档案类型
    deactivateArchiveType(id) {
      return service({
        url: `/api/ArchiveTypes/${id}/deactivate`,
        method: 'post'
      })
    },
    // 更新排序
    updateArchiveTypeSort(data) {
      return service({
        url: '/api/ArchiveTypes/sort',
        method: 'put',
        data
      })
    }
  },
  
  // File 模块
  file: {
    // 上传文件
    uploadFile(file) {
      const formData = new FormData()
      formData.append('file', file)
      return service({
        url: '/api/File',
        method: 'post',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    },
    // 上传图片
    uploadImage(file) {
      const formData = new FormData()
      formData.append('file', file)
      return service({
        url: '/api/File/upload',
        method: 'post',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    }
  },
  
  // Vehicles 模块
  vehicles: {
    // 获取车辆列表
    getVehicles(params) {
      return service({
        url: '/api/Vehicles',
        method: 'get',
        params
      })
    },
    // 创建车辆
    createVehicle(data) {
      return service({
        url: '/api/Vehicles',
        method: 'post',
        data
      })
    },
    // 获取单个车辆详情
    getVehicle(id) {
      return service({
        url: `/api/Vehicles/${id}`,
        method: 'get'
      })
    },
    // 更新车辆
    updateVehicle(id, data) {
      return service({
        url: `/api/Vehicles/${id}`,
        method: 'put',
        data
      })
    },
    // 删除车辆
    deleteVehicle(id) {
      return service({
        url: `/api/Vehicles/${id}`,
        method: 'delete'
      })
    },
    // 获取车辆有效期统计
    getVehicleExpiryStatistics(params) {
      return service({
        url: '/api/Vehicles/expiry-statistics',
        method: 'get',
        params
      })
    },
    // 行驶证识别
    recognizeVehicleLicense(data) {
      return service({
        url: '/api/Vehicles/recognize-license',
        method: 'post',
        data
      })
    },
    // 批量删除车辆
    batchDeleteVehicles(ids) {
      return service({
        url: '/api/Vehicles/batch',
        method: 'delete',
        data: ids
      })
    }
  },
  
  // Warehouse 模块
  warehouse: {
    // 获取仓库列表
    getWarehouses(params) {
      return service({
        url: '/api/Warehouse/list',
        method: 'get',
        params
      })
    },
    // 创建仓库
    createWarehouse(data) {
      return service({
        url: '/api/Warehouse/create',
        method: 'post',
        data
      })
    },
    // 获取单个仓库详情
    getWarehouse(id) {
      return service({
        url: `/api/Warehouse/${id}`,
        method: 'get'
      })
    },
    // 更新仓库
    updateWarehouse(id, data) {
      return service({
        url: `/api/Warehouse/update`,
        method: 'put',
        data
      })
    },
    // 删除仓库
    deleteWarehouse(id) {
      return service({
        url: `/api/Warehouse/${id}`,
        method: 'delete'
      })
    },
    // 批量删除仓库
    batchDeleteWarehouses(ids) {
      return service({
        url: '/api/Warehouse/batch',
        method: 'delete',
        data: ids
      })
    }
  },

  // OrderPlan 模块
  orderPlan: {
    // 提交调运计划
    submit(data) {
      return service({
        url: '/api/OrderPlan',
        method: 'post',
        data
      })
    }
  }
}

const request =   function(url,data,method){
	const requestData = {}
	if(method==='get'){
		requestData.params=data
	}else{
		requestData.data=data
	}
	return service({
	  url,
	  method: method||'get',
	  ...requestData
	})
}

export default api
//export default request
